import { isUnusableZoneDisplayName } from '../utils/zoneDisplayName';
import { readSavedZoneMeta } from './zoneRestorePick';
export function labelFromSavedMeta(zoneId: string, fallback: string): string {
  const meta = readSavedZoneMeta();
  if (meta?.id === zoneId && meta.name && meta.name !== 'Network player' && !isUnusableZoneDisplayName(meta.name, zoneId)) {
    return meta.name;
  }
  return fallback;
}
